export function noOp() {
    console.log('Default function called');
}

export const EMPTY_OBJECT = {};
